// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/Page/styles.scss
// module id = 728
// module chunks = 0